import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.background.dark};
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 4px;
  background: transparent;
  color: inherit;
  cursor: pointer;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
